import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import '../../styles/Pages.css';

function AboutSanstha() {
    return (
        <div className="page-wrapper">
            <Navbar />
            <div className="page-hero">
                <p className="page-breadcrumb"><a href="/">Home</a> › About Us › About Sanstha</p>
                <h1>About Sanstha</h1>
                <p>Ahmednagar Jilha Maratha Vidya Prasarak Samaj</p>
            </div>
            <div className="page-content">
                <div className="info-card">
                    <h2>About the Managing Organization</h2>
                    <p>
                        <strong>Ahmednagar Jilha Maratha Vidya Prasarak Samaj</strong> is a long-standing educational trust committed to bringing quality education to the rural and semi-urban communities of Ahmednagar district, Maharashtra. The Samaj was established with the noble vision of empowering underprivileged and rural populations through access to higher education.
                    </p>
                    <p>
                        Over the years, the Samaj has established several educational institutions across Ahmednagar district, playing a pivotal role in the socio-economic development of the region. Its flagship institution in Nighoj — <strong>Shri Mulikadevi Mahavidyalaya</strong> — was inaugurated in the academic year 2013-14 with a commitment to delivering value-based education.
                    </p>
                </div>
                <div className="info-card">
                    <h2>Our Motto</h2>
                    <p style={{ fontSize: '1.15rem', fontStyle: 'italic', color: '#2d6a4f', fontWeight: 600 }}>
                        "Empowering the masses through quality education."
                    </p>
                    <p>
                        The Samaj believes that education is the most powerful tool for uplifting society. Every initiative undertaken by the trust reflects this foundational belief — ensuring that no student is denied quality education due to geographic or economic barriers.
                    </p>
                </div>
                <div className="info-card">
                    <h2>Key Milestones</h2>
                    <ul>
                        <li>Established multiple educational institutions across Ahmednagar district</li>
                        <li>Founded Shri Mulikadevi Mahavidyalaya, Nighoj in 2013-14</li>
                        <li>College achieved NAAC accreditation with "B" Grade</li>
                        <li>Strong focus on rural student enrollment and scholarship opportunities</li>
                        <li>Promotion of NSS, sports, cultural activities, and community service</li>
                    </ul>
                </div>
            </div>
            <Footer />
        </div>
    );
}
export default AboutSanstha;
